import React from 'react';
import { MDBDataTable } from 'mdbreact';
import '../../style/DataTable.css';

const ClubsDataTable = (props) => {
  const reducePlayercount = (total, players) => {
    return total + players.length;
  };
  const getClubsData = () => {
    let rowData = [];
    let totalTeams = 0;
    props.clubs.map((row) => {
      let clubTeams = 0;
      if (row.teams != null) {
        for (const team of row.teams) {
          if (team.players != null && team.players.length > 0) {
            clubTeams++;
            totalTeams++;
          }
        }
      }
      if (clubTeams === 0) {
        return null;
      }
      return rowData.push({
        name: row.name ? row.name : 'N/A',
        numberOfTeams: clubTeams,
        numberOfPlayers:
          row.teams && row.teams.length > 0
            ? row.teams.map((team) => team.players).reduce(reducePlayercount, 0)
            : 0,
      });
    });
    if (!rowData.length) {
      return null;
    }

    rowData.sort((a, b) => a.name.localeCompare(b.name, 'et'));

    rowData.push({
      name: 'Kokku',
      numberOfTeams: totalTeams,
      numberOfPlayers: props.clubs
        ? props.clubs.reduce(function (total, club) {
            return (
              total +
              (club.teams
                ? club.teams.reduce(function (total, team) {
                    return total + (team.players ? team.players.length : 0);
                  }, 0)
                : 0)
            );
          }, 0)
        : 0,
    });

    return {
      columns: [
        {
          label: 'Nimi',
          field: 'name',
        },
        {
          label: 'Võistkondade arv',
          field: 'numberOfTeams',
        },
        {
          label: 'Mängijate arv',
          field: 'numberOfPlayers',
        },
      ],
      rows: rowData,
    };
  };
  const tableData = getClubsData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          className={`clubsDataTable`}
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default ClubsDataTable;
